<template>
  <sup v-if="marker" class="text-[75%]">{{ marker }}</sup>
</template>

<script setup lang="ts">
// Every `*` / `**` in the campaign, wherever it is placed: `InlineMarkdown` renders it for a
// `[^*]` token in prose, `MetalView` paints it onto labels the metal doesn't own (the score
// rows, the countries heading), and `FootnotesList` heads each note with it. One component so
// the marker on the word and the marker on its note can't drift apart.
//
// Inert on purpose: the note is in the same scroll, and a jump would have to go through
// Lenis, which owns `scrollTop` and runs one instance per container.
//
// The root gates itself, so callers pass `:marker` unconditionally — and glue the tag to the
// preceding word, since whitespace before a `<sup>` renders as a literal space. 75% matches
// `SourcesList`'s marker, and `<sup>`'s native position costs no leading (measured: `super`,
// `top` and `baseline` all leave a citing paragraph at 140px).
defineProps<{ marker?: string }>()
</script>
